import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from '../../i18n';
import { colors } from '../../theme/tokens';

/**
 * Rodapé minimalista da tela de cartão. O legado exibia só o selo de ambiente
 * seguro, sem SAC nem links — mantido igual para não distrair no checkout.
 */
export function SecureFooter() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 4,
        backgroundColor: colors.surface,
        borderTop: `1px solid ${colors.border}`,
      }}
    >
      <Box sx={{ maxWidth: 1280, mx: 'auto', px: 2, textAlign: 'center' }}>
        <Typography sx={{ fontSize: '0.875rem', color: colors.textMuted }}>
          {t.creditCard.secureFooter}
        </Typography>
      </Box>
    </Box>
  );
}
